<div>
  <div class="row-no-margin col-md-12">
    <div class="col-md-6 clear-padding ">
      <span class="section-header">Custom Lead Time Rules</span>
    </div>
    
    <div class="col-md-6 clear-padding" style="align-items:center;">      
      <div class="row-no-margin col-md-12" style="margin-bottom:5px;">
        <div class="col-md-3"></div>
        <div class="col-md-8">
          <button class="blue clickable" (click)="CreateNewRule()">Create Rule</button>
        </div>        
      </div>      
      <div class=" row-no-margin col-md-12" style="align-items:center;">
        <div class="col-md-3">
          <input [(ngModel)]="TestConfigString" style="margin-right: 10px; justify-self: center;" placeholder="Item #/Config String" />
        </div>
        <div class="col-md-3">
          <button class="bg-white clickable" (click)="TestConfigStringLeadTime()">Test Config String</button>
        </div>
        <div class="col-md-3">
          <span [hidden]="TestConfigResults == ''" style="margin-left:10px;margin-right:10px;">{{TestConfigResults}}</span>
        </div>        
      </div>
    </div>
  </div>
 
  <div class="row-no-margin col-md-10 p-3">
    <table class="mainGrid" style="width:100%;">
      <tr>
        <th style="text-align:center;">Test</th>
        <th style="text-align:center;">Lead Time Days</th>
        <th style="text-align:center;">Expiration Date</th>
        <th style="text-align:center;">Custom Message</th>
        <th style="text-align:center;">Edit</th>
        <th style="text-align:center;">Delete</th>
      </tr>
      @for(rule of Rules;track rule;){
      @if(rule.Deleted == false){
      <tr>
        <td style="text-align:center;">
          {{rule.RuleTest}}
        </td>
        <td style="text-align:center;">
          {{rule.LeadTimeDays}}
        </td>
        <td style="text-align:center;">
          {{rule.ExpirationDate | date:'shortDate'}}
        </td>
        <td style="text-align:center;">
          {{rule.CustomMessage}}
        </td>
        <td style="text-align:center;">
          <fa-icon [icon]="faEdit" (click)="EditRule(rule)" class="fa-light fa-2x  clickable blue-color"></fa-icon>
          
        </td>
        <td style="text-align:center;">
          <fa-icon [icon]="faX" (click)="DeleteRule(rule)" class="fa-light fa-2x  clickable blue-color"></fa-icon>
        </td>
      </tr>
      }
      }
    </table>

  </div>
</div>
